import s from '@/components/orders/new-order/live.module.css';

export const WarningBanner = ({
	warningMessage,
	warningMessageVisible,
	setWarningMessageVisible,
	isMasterOrAdmin,
}) => {
	if (!warningMessage) return null;

	return (
		<div
			className={s.emergency_text}
			style={
				warningMessage?.length > 200
					? { fontSize: 17.5, lineHeight: '22px' }
					: warningMessage?.length > 130
						? { fontSize: 19.5, lineHeight: '24.5px' }
						: {}
			}
		>
			{warningMessage?.length > 200 && !warningMessageVisible
				? warningMessage.substring(0, 200)
				: warningMessage}
			{isMasterOrAdmin && warningMessage?.length > 200 && (
				<span
					className='pointer ml-1.5 text-cyan-600!'
					onClick={() => setWarningMessageVisible(s => !s)}
				>
					{warningMessageVisible ? 'Απόκρυψη' : 'Εμφάνιση'}
				</span>
			)}
		</div>
	);
};
